/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import SoftDatePicker from "components/SoftDatePicker";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import DatePicker from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "nowrap",
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

function TaxPersonalTable({ setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      fullname: "",
      taxId: "",
      identity: "",
      number: "",
      date: new Date(),
    },
  ]);

  useEffect(() => {
    setFieldValue("valuesTableII", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, type } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleChangeDate = (date, id) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };

  const handleAdd = () => {
    setData((prev) => [
      ...prev,
      {
        id: uuidV4(),
        fullname: "",
        taxId: "",
        identity: "",
        number: "",
        date: new Date(),
      },
    ]);
  };

  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Typography variant="h5">
        II. THÔNG TIN TỔ CHỨC, CÁ NHÂN NHẬN CHUYỂN NHƯỢNG VÔN GÓP, NHẬN CHUYỂN NHƯỢNG CHỨNG KHOÁNG
      </Typography>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={2}
                style={{ textAlign: "center", maxWidth: 10 }}
              >
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Họ và tên
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mã số thuế
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số CMND/CCCD/Hộ chiếu
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Hợp đồng chuyển nhượng
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>Số</Td>
              <Td style={{ textAlign: "center" }}>Ngày/tháng/năm</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>[23]</Td>
              <Td style={{ textAlign: "center" }}>[24]</Td>
              <Td style={{ textAlign: "center" }}>[25]</Td>
              <Td style={{ textAlign: "center" }}>[26]</Td>
              <Td style={{ textAlign: "center" }}>[27]</Td>
              <Td style={{ textAlign: "center" }}>[28]</Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="fullname"
                    value={item.fullname}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxId"
                    value={item.taxId}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="identity"
                    value={item.identity}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="number"
                    value={item.number}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <DatePicker
                    style={{
                      fontSize: 13,
                      color: "#495057",
                      border: "0.0625rem solid #d2d6da",
                      background: "#fff",
                      padding: "0.5rem 0.75rem",
                      width: "100%",
                      borderRadius: "0.5rem",
                    }}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="2"
                    value={item.date}
                    onChange={(date) => handleChangeDate(date, item.id)}
                  />
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
    </Box>
  );
}

export default memo(TaxPersonalTable);

function InputTable(props) {
  const { id, onChange, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
